import { render, staticRenderFns } from "./OrderablePreviewNote.vue?vue&type=template&id=40af1013&"
import script from "./OrderablePreviewNote.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports